import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { ComponentProps, FC, forwardRef } from 'react'
import { styled } from '../../lib/stitches'
import { Check } from './icons'

const StyledCheckbox = styled(CheckboxPrimitive.Root, {
  all: 'unset',
  width: '20px',
  height: '20px',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '$gray3',
  boxSizing: 'border-box',
  transition: 'all 100ms ease',
  '&:hover': { borderColor: '$gray15' },
  '&:active': { borderColor: '$gray15' },
  '&[data-state="checked"]': {
    background: '$blue05',
    borderColor: 'transparent'
  }
})

const StyledIndicator = styled(CheckboxPrimitive.Indicator, {
  color: '$gray01'
})

/** Styled Checkbox component based on Radix UI Primitive
 * @prop `checked: boolean | 'indeterminate' = false` - state prop
 * @prop `onCheckedChange?(checked: boolean | 'indeterminate'): void` - callback in case of change
 */
const Checkbox: FC<ComponentProps<typeof StyledCheckbox>> = forwardRef((props, ref) => {
  return (
    <StyledCheckbox ref={ref} {...props}>
      <StyledIndicator asChild>
        <Check />
      </StyledIndicator>
    </StyledCheckbox>
  )
})

export default Checkbox
